export const STATUS = 'status';
export const ALLOCATION_STATUS = 'Valuation Status';
export const COMPANY_NAME_FIELD = 'company_name';
export const COMPANY_NAME_HEADER = 'Company Name';
export const MARKET_DATE_FIELD = 'market_date';
export const MARKET_DATE_HEADER = 'Market Date';
export const IS_READY_FOR_AUDIT_FIELD = 'is_ready_for_audit';
export const IS_FIRM_OWNED_FIELD = 'is_firm_owned';
export const IS_FIRM_OWNED_HEADER = 'Owner';
export const IS_READY_FOR_AUDIT_HEADER = 'Audit';
export const BACKSOLVE_FIELD = 'Bulk Backsolve';
export const AS_OF_DATE_FIELD = 'as_of_date';
export const OPM_BACKSOLVE_DATE_FIELD = 'opm_backsolve_date';
export const AS_OF_DATE_HEADER = 'As of Date';
export const OPM_BACKSOLVE_DATE_HEADER = 'OPM Backsolve Date';
export const ADJUSTMENT_TYPE_SELECTION_FIELD = 'adjustment_type_selection';
export const ADJUSTMENT_TYPE_SELECTION_HEADER = 'Value to Adjust';
export const ADJUSTMENT_SELECTED_FIELD = 'adjustment_selected';
export const METRIC_HEADER = 'Select Adjustment Metric';
export const METRIC_FIELD = 'metric';
export const ADJUSTMENT_SELECTED_HEADER = 'Select Percent Adjustment';
export const MIN_PERCENT_CHANGE_FIELD = 'min_percent_change';
export const MIN_PERCENT_CHANGE_HEADER = 'Min Percent Change';
export const MAX_PERCENT_CHANGE_FIELD = 'max_percent_change';
export const MAX_PERCENT_CHANGE_HEADER = 'Max Percent Change';

// Column definitions for MUI Table
export const columnHeaders = [
  {
    field: COMPANY_NAME_FIELD,
    headerName: COMPANY_NAME_HEADER,
    isInitialColumn: true,
    subColumns: [],
    linkedVisibleColumns: [],
  },
  {
    field: MARKET_DATE_FIELD,
    headerName: MARKET_DATE_HEADER,
    isInitialColumn: true,
    subColumns: [],
    linkedVisibleColumns: [],
  },
  {
    field: STATUS,
    headerName: ALLOCATION_STATUS,
    isInitialColumn: true,
    subColumns: [],
    linkedVisibleColumns: [],
  },
  {
    field: IS_FIRM_OWNED_FIELD,
    headerName: IS_FIRM_OWNED_HEADER,
    isInitialColumn: false,
    subColumns: [],
    linkedVisibleColumns: [],
  },
  {
    field: IS_READY_FOR_AUDIT_FIELD,
    headerName: IS_READY_FOR_AUDIT_HEADER,
    subColumns: [],
    linkedVisibleColumns: [],
    isInitialColumn: false,
  },
  {
    field: BACKSOLVE_FIELD,
    headerName: BACKSOLVE_FIELD,
    linkedVisibleColumns: [MARKET_DATE_FIELD],
    isInitialColumn: false,
    subColumns: [
      {
        field: AS_OF_DATE_FIELD,
        headerName: AS_OF_DATE_HEADER,
        isEditable: true,
      },
      {
        field: OPM_BACKSOLVE_DATE_FIELD,
        headerName: OPM_BACKSOLVE_DATE_HEADER,
      },
      {
        field: ADJUSTMENT_TYPE_SELECTION_FIELD,
        headerName: ADJUSTMENT_TYPE_SELECTION_HEADER,
      },
      {
        field: METRIC_FIELD,
        headerName: ADJUSTMENT_SELECTED_HEADER,
      },
      {
        field: ADJUSTMENT_SELECTED_FIELD,
        headerName: METRIC_HEADER,
      },
      {
        field: MIN_PERCENT_CHANGE_FIELD,
        headerName: MIN_PERCENT_CHANGE_HEADER,
      },
      {
        field: MAX_PERCENT_CHANGE_FIELD,
        headerName: MAX_PERCENT_CHANGE_HEADER,
      },
    ],
  },
];

export const BULK_REFRESH_MARKET_DATA_APP_BAR_TITLE = 'Refresh Market Data';
export const BULK_REFRESH_MARKET_DATA_APP_BAR_SUBTITLE =
  'Public Comps data from Capital IQ will be updated and optionally select a new market date to apply to all of the selected companies';
export const BULK_REFRESH_MARKET_DATA_ACTION_LABEL = 'UPDATE';
